'use strict';

window.$ = window.jQuery = $;

import './about-us.js'